import { useCallback } from 'react';

import { useAppDispatch, logout } from '../state';

export function useLogout() {
  const dispatch = useAppDispatch();
  const onSignOut = useCallback(
    async (refresh = true) => {
      try {
        await dispatch(logout()).unwrap();
      } catch (err) {
        console.error(err);
      } finally {
        if (refresh) {
          location.href = '/create/login';
        }
      }
    },
    [dispatch]
  );

  return { onSignOut };
}
